<template>
 <div class="tusd-wrap wrap-bg">
  	<div class="page-title">
           <button :class="{'active':currentView=='orderbuylist'}" @click="tabChange('orderbuylist')">购买</button>
           <button :class="{'active':currentView=='order'}" @click="tabChange('order')">出售</button>
     </div>
     <div class="order-scroll" >
         <div ref="tabChange" :is="currentView"></div>
     </div>
  </div>
</template>
<script>
import order from "./order.vue"
import orderbuylist from "./orderBuyList.vue"
export default {
  name: 'orderTab',
  data(){
  	return {
        currentView: 'order' // 默认选中第一项
    }
  },
  components:{
      orderbuylist,
      order
  },
  methods:{
      setTab(){
         this.$store.commit('storeParams',{
              name:"orderTab",
              view:this.currentView
         })
      },
      tabChange(tabview){
        this.currentView = tabview;
        this.$refs.tabChange.refreshSearch()
        if(this.$store.state.routerStore.orderDetails !== undefined){
          this.$store.state.routerStore.orderDetails.searchForm = {}
        }
        this.setTab();
      }
  },
  created(){
    let that=this;
    that.$parent.active=that.$store.state.routerStore.menu.active;
    if(that.$store.state.routerStore.orderTab){
      that.currentView=that.$store.state.routerStore.orderTab.view;
    }
    that.setTab();
  }
}
</script>

<style lang="less" scoped>
.order-scroll{
		height: calc(100% - 115px);
	}
	.page-title{
        text-align: center;
        button{
             font-size: 16px !important;
            color: #fff;
            padding: 5px 25px !important;
            border-radius: 3px; 
            background-color: #2c3454;
            &:first-child{
                margin-right: 15px;
            }
            &.active{
                background-color: #569eff;
            }
        }
    }
</style>